import { FunctionalComponent, h } from '@stencil/core';
import { AppLink, AppMedia, AppRTE } from './'
import get from 'lodash/get'

interface Sections2ColCTA {
    __component?: string;
    data?: any;
}


export const Sections2ColCTA: FunctionalComponent<Sections2ColCTA> = ({ data }) => {

    let { Title, Description, Media, Link, Dark, MediaLeft, product } = data;

    if (product && product.data) {
        Title = Title || (get(product.data, 'attributes.Title'))
        Description = Description || get(product.data, 'attributes.Description')
        Media = Media.data ? Media : get(product.data, 'attributes.Hero.Media')
        Link = Link || { URL: '/' + get(product.data, 'attributes.Page.data.attributes.Slug'), Label: `View ${get(product.data, 'attributes.Title')}` }
    }


    return [
        <section class='uk-section uk-padding-remove-top uk-container uk-container-xlarge'>
            <div class='uk-child-width-1-1 uk-child-width-1-2@m uk-flex uk-grid-collapse' uk-grid>
                <div>
                    <div class="uk-height-1-1 uk-cover-container">
                        <AppMedia className='uk-width-1-1' size="(max-width: 638px) 80vw, (max-width: 958px) 50vw, 50vw" media={Media} cover />
                    </div>
                </div>
                <div>
                    <div class={`uk-position-relative uk-overflow-hidden uk-padding uk-height-1-1 ${!MediaLeft ? 'uk-flex-first' : ''} ${Dark ? 'uk-background-primary-diag uk-light' : 'uk-muted-striped'}`}>
                        <div class="uk-position-relative">
                            <h2 class="uk-heading-large wsio-darker-green uk-text-uppercase">{Title}</h2>
                            <AppRTE markdown={Description} />
                            <AppLink className={`uk-button ${Dark ? 'uk-button-default' : 'uk-button-primary'}`} data={Link} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    ]
};